import React from 'react';
import { CustomLink } from 'src/components/CustomLink/CustomLink';
import { Svg } from 'src/components/Svg/Svg';
import { LazyImg } from 'src/hooks/useLazyLoad';

import classes from './ProductShopByCategory.scss';

type Category = {
    title: string;
    link: string;
    image: string;
};

const categories: Category[] = [
    {
        title: 'Jackets',
        link: '/jackets',
        image: require('../../../static/img/workwear/category-grid/jackets.png'),
    },
    {
        title: 'T-Shirts',
        link: '/t-shirts',
        image: require('../../../static/img/workwear/category-grid/t-shirts-blue.png'),
    },
    {
        title: 'Polo Shirts',
        link: '/polo-shirts',
        image: require('../../../static/img/workwear/category-grid/polo-shirts-grey.png'),
    },
    {
        title: 'Hi Vis',
        link: '/hi-vis',
        image: require('../../../static/img/workwear/category-grid/hi-vis-2.png'),
    },
    {
        title: 'Trousers',
        link: '/trousers',
        image: require('../../../static/img/workwear/category-grid/trousers.png'),
    },
    {
        title: 'Contrast T-Shirts',
        link: '/t-shirts/contrast-t-shirts',
        image: require('../../../static/img/workwear/category-grid/contrast-t-shirts.png'),
    },
];

export const ProductShopByCategory: React.FC = () => (
    <section className={classes.root} aria-labelledby="product-shop-by-category-title">
        <div className={classes.content}>
            <h2 id="product-shop-by-category-title" className={classes.title}>
                Shop by Category
            </h2>
            <CustomLink link="/workwearclothing" className={classes.button}>
                View All
            </CustomLink>
        </div>

        <div className={classes.grid}>
            {categories.map((category) => (
                <CustomLink key={category.title} link={category.link} className={classes.card}>
                    <span className={classes.cardTitle}>
                        {category.title}
                        <Svg name="arrow-right" className={classes.icon} />
                    </span>
                    <LazyImg src={category.image} alt={category.title} className={classes.image} />
                </CustomLink>
            ))}
        </div>
    </section>
);

export default ProductShopByCategory;
